import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full topBar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fs-sm" }, "Agencias - ", -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-10 offset-md-1" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-7" }
const _hoisted_8 = { class: "fs-1 fw-bold" }
const _hoisted_9 = {
  class: "col-md-5",
  style: {"text-align":"right"}
}
const _hoisted_10 = { style: {"display":"inline-flex","list-style-type":"none"} }
const _hoisted_11 = { style: {"margin-right":"5px"} }
const _hoisted_12 = { style: {"margin-right":"5px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "row mt-3",
  style: {"background":"#191f26","border-bottom":"1px solid #393840","border-top-left-radius":"10px","border-top-right-radius":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 p-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Información de la agencia")
  ])
], -1)
const _hoisted_14 = {
  class: "row",
  style: {"background":"#191f26","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"}
}
const _hoisted_15 = { class: "col-md-2 p-4" }
const _hoisted_16 = { style: {"display":"blocks","list-style-type":"none"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Estado")
], -1)
const _hoisted_18 = { class: "mt-3" }
const _hoisted_19 = { class: "col-md-2 p-4" }
const _hoisted_20 = { style: {"display":"blocks","list-style-type":"none"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ciudad")
], -1)
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = { class: "col-md-2 p-4" }
const _hoisted_24 = { style: {"display":"blocks","list-style-type":"none"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Domicilio")
], -1)
const _hoisted_26 = { class: "mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 p-4" }, [
  /*#__PURE__*/_createElementVNode("ul", { style: {"display":"blocks","list-style-type":"none"} }, [
    /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Colonia")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "mt-3" }, "Atlas")
  ])
], -1)
const _hoisted_28 = { class: "col-md-1 p-4" }
const _hoisted_29 = { style: {"display":"blocks","list-style-type":"none"} }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "C.P.")
], -1)
const _hoisted_31 = { class: "mt-3" }
const _hoisted_32 = { class: "col-md-3 p-4" }
const _hoisted_33 = { style: {"display":"blocks","list-style-type":"none"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", { class: "fs-5 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Whatsapp")
], -1)
const _hoisted_35 = { class: "mt-3" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "row mt-3" }
const _hoisted_38 = { class: "col-md-10 offset-md-1" }
const _hoisted_39 = { class: "nav nav-tabs nav-line-tabs fs-base overflow-visible" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("b", null, "Vehículos", -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("b", null, "Usuarios", -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "row mt-5" }
const _hoisted_47 = { class: "col-md-10 offset-md-1" }
const _hoisted_48 = {
  class: "tab-content",
  id: "kt_customer_tab_pane_tab_content"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Usuarios asignados", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Vehicles = _resolveComponent("Vehicles")!
  const _component_Users = _resolveComponent("Users")!
  const _component_ModalNewAgency = _resolveComponent("ModalNewAgency")!
  const _component_ModalDeleteAgency = _resolveComponent("ModalDeleteAgency")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, [
        _createTextVNode("Detalles de la agencia   |   "),
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.agencyData.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.agencyData.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", _hoisted_11, [
                  _withDirectives(_createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary fs-base",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#deleteAgencyModal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAgency(_ctx.agencyData.id)))
                  }, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/trash.svg" })
                    ]),
                    _createTextVNode(" Eliminar agencia ")
                  ], 512), [
                    [_vShow, _ctx.can('Eliminar agencia')]
                  ])
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _withDirectives(_createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary fs-base",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#newAgencyModal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editAgency(_ctx.agencyId)))
                  }, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/edit-2.svg" })
                    ]),
                    _createTextVNode(" Editar ")
                  ], 512), [
                    [_vShow, _ctx.can('Editar agencia')]
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("li", _hoisted_18, _toDisplayString(_ctx.agencyData.state), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("ul", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("li", _hoisted_22, _toDisplayString(_ctx.agencyData.city), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("ul", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("li", _hoisted_26, _toDisplayString(_ctx.agencyData.address), 1)
              ])
            ]),
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("ul", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("li", _hoisted_31, _toDisplayString(_ctx.agencyData.cp), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("ul", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("li", _hoisted_35, [
                  _createElementVNode("a", {
                    href: _ctx.urlWhats,
                    target: "_blank",
                    class: "link-blue"
                  }, "Abrir chat", 8, _hoisted_36)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("ul", _hoisted_39, [
            _createElementVNode("li", _hoisted_40, [
              _createElementVNode("a", {
                role: "presentation",
                class: _normalizeClass(["nav-link fs-base", _ctx.tabActive == 1 ? 'active': '']),
                "data-bs-toggle": "tab",
                href: "#panel_vehiculos",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabActive = 1))
              }, _hoisted_42, 2)
            ]),
            _createElementVNode("li", _hoisted_43, [
              _createElementVNode("a", {
                role: "presentation",
                class: _normalizeClass(["nav-link fs-base", _ctx.tabActive == 2 ? 'active': '']),
                "data-bs-toggle": "tab",
                href: "#panel_users",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tabActive = 2))
              }, _hoisted_45, 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", {
              id: "panel_vehiculos",
              class: _normalizeClass(["py-0 tab-pane fade", _ctx.tabActive == 1 ? 'active show': '']),
              role: "tabpanel"
            }, [
              _createVNode(_component_Vehicles, {
                agencyId: _ctx.agencyData.id
              }, null, 8, ["agencyId"])
            ], 2),
            _createElementVNode("div", {
              id: "panel_users",
              class: _normalizeClass(["py-0 tab-pane fade mt-5", _ctx.tabActive == 2 ? 'active show': '']),
              role: "tabpanel"
            }, [
              _hoisted_49,
              _createVNode(_component_Users, {
                sub: true,
                idAgency: _ctx.agencyData.id,
                nameAgency: _ctx.agencyData.name,
                showAgency: _ctx.showAgency
              }, null, 8, ["idAgency", "nameAgency", "showAgency"])
            ], 2)
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalNewAgency, {
      onFinish: _cache[4] || (_cache[4] = ($event: any) => (_ctx.finishAction($event))),
      agencyId: _ctx.idToEdit,
      type: _ctx.type
    }, null, 8, ["agencyId", "type"]),
    _createVNode(_component_ModalDeleteAgency, {
      onFinishDelete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.finishAction($event))),
      agencyId: _ctx.agencyId
    }, null, 8, ["agencyId"])
  ], 64))
}